module.exports = __webpack_public_path__ + "static/media/2.a9134bb3.jpg";